import React from 'react';
import Lottie from 'lottie-react';

export default function LottieIcon({ animationData, size = 60 }) {
  return (
    <div style={{ width: size, height: size }}>
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={{ width: '100%', height: '100%', pointerEvents: 'none' }}
      />
    </div>
  );
}